<template lang="html">

  <section class="login d-flex align-center" height="100%">
    <v-card class="pa-5 card" height="300" width="300"> 
      <v-card-title>התחברות</v-card-title>
    <v-form>
      <v-text-field type="email" label="אימייל" v-model="form.email" append-icon="mdi mdi-email"></v-text-field>
      <v-text-field type="password" label="סיסמא" v-model="form.password" append-icon="mdi mdi-lock"></v-text-field>
      <v-btn color="primary" block @click="login"><v-icon left>mdi-key</v-icon>התחבר</v-btn>
      </v-form>
      </v-card>
  </section>

</template>

<script lang="js">

import * as firebase from "firebase/app";
  export default  {
    name: 'login',
    props: [],
    mounted () {

    },
    data () {
      return {
        form: {}
      }
    },
    methods: {
      login() {
        firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password);

      }
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .login {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #541654;
}
.card {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
